import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, Menu, Tabs, Tab, FormHelperText, FormLabel, Card, ListItemText, ListItemIcon, Chip } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import SimpleTable from "../../Common/SimpleTable";

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
import ApplyForLeave from '../LeaveComponent/ApplyForLeave';

// -----------------------------------------------------------------------------------------------------
const viewStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const TextAccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#FFF', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function LeaveRequest({ requestExecutive, selectedRequestExecutive, handleRequestExecutive, requestProject, selectedRequestProject, handleRequestProject, requestStatus, selectedRequestStatus, handleRequestStatus, handleLeaveRequestFilter, handleLeaveRequestReset, leaveRequestRow, leaveRequestColumn, isView, setIsView, selectedRequestRow, leaveRequestData, handleApprove, handleReject, handleCancelLeave, pastLeaveData, upcomingLeaveData, pastLeaveColumns, upcomingLeaveColumns, teamImpactColumns, teamImpactLeaveData, projectImpactLeaveData, pageSize5, setPageSize5, requestDepartment, selectedRequestDepartment, handleRequestDepartment }) {


    // const tableMaxHeight = date.length > 0 ? "24vh" : "60vh";
    const tableMaxHeight = "24vh";

    return (
        <>
            {!isView && (
                <Box sx={{ p: 2 }}>
                    <>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                            <FormControl size="small" fullWidth sx={{ width: 180 }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="executive"
                                    value={selectedRequestExecutive.find((option) => option.Id === requestExecutive) || ""}
                                    onChange={(_, newValue) => handleRequestExecutive(newValue)}
                                    options={selectedRequestExecutive}
                                    getOptionLabel={(option) => option.Name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Executive" />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.Id}>
                                            {option.Name}
                                        </li>
                                    )}
                                />

                            </FormControl>
                            <FormControl size="small" fullWidth sx={{ width: 180 }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="project"
                                    value={selectedRequestProject.find((option) => option.ProjectId === requestProject) || ""}
                                    onChange={(_, newValue) => handleRequestProject(newValue)}
                                    options={selectedRequestProject}
                                    getOptionLabel={(option) => option.Name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Project" />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.ProjectId}>
                                            {option.Name}
                                        </li>
                                    )}
                                />

                            </FormControl>
                            <FormControl size="small" fullWidth sx={{ width: 180 }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="leaveHistory"
                                    value={selectedRequestStatus.find((option) => option.Id === requestStatus) || ""}
                                    onChange={(_, newValue) => handleRequestStatus(newValue)}
                                    options={selectedRequestStatus}
                                    getOptionLabel={(option) => option.Name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Status" />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.Id}>
                                            {option.Name}
                                        </li>
                                    )}
                                />

                            </FormControl>
                            <FormControl size="small" fullWidth sx={{ width: 180 }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="department"
                                    value={selectedRequestDepartment.find((option) => option.Id === requestDepartment) || ""}
                                    onChange={(_, newValue) => handleRequestDepartment(newValue)}
                                    options={selectedRequestDepartment}
                                    getOptionLabel={(option) => option.TeamName || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Department" />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.Id}>
                                            {option.TeamName}
                                        </li>
                                    )}
                                />

                            </FormControl>
                            <Tooltip title="Filter">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleLeaveRequestFilter}
                                    sx={{ minWidth: 40, }}

                                >
                                    <Icon icon="material-symbols:search" width="20" height="20" sx={{ mr: '3px' }} />
                                </Button>
                            </Tooltip>

                            {/* Reset */}
                            <Tooltip title="Reset">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleLeaveRequestReset}
                                    sx={{ minWidth: 40, }}

                                >
                                    <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                                </Button>
                            </Tooltip>
                        </Stack>

                        {/* DataGrid for History */}
                        <Box sx={{ height: '56vh', width: '100%', }}>
                            <DataGrid rows={leaveRequestData} columns={leaveRequestColumn} density="compact" getRowId={(row) => row.ID} getRowHeight={() => 'auto'}
                                components={{ Toolbar: GridToolbar, }}
                                pagination
                                paginationMode="client"
                                rowsPerPageOptions={[25, 50, 100]}
                                pageSize={pageSize5}
                                onPageSizeChange={(newPageSize) => setPageSize5(newPageSize)} />
                        </Box>
                    </>
                </Box>
            )}

            <Box sx={{ p: 2, }}>
                {isView && selectedRequestRow && (
                    <>
                        <Box mb={1}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" pb={1}>
                                {/* Back Button */}
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => setIsView(false)}
                                >
                                    <ArrowBackIosNewRoundedIcon sx={{ color: '#838383', width: 19, height: 19, mr: 0.5 }} />
                                    <Typography sx={{ color: '#3D3D3D', fontSize: 14, fontWeight: 500 }}>
                                        Back
                                    </Typography>
                                </Box>

                                {/* Center Name */}
                                <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                                    {selectedRequestRow?.Name || "-"}
                                </Typography>

                                <Box width="80px" />
                            </Box>
                            <Divider />
                        </Box>

                        {/* ✅ MAIN CONTENT */}
                        <Box pt={1}>
                            <Grid container spacing={3}>
                                {/* LEFT PANEL: Leave Details */}
                                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Card
                                        sx={{
                                            width: "100%",
                                            height: 250, // ✅ fixed base height like UI
                                            border: "1px solid #E5E7EB",
                                            borderRadius: 1,
                                            boxShadow: "none",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {/* CONTENT */}
                                        <Box display="flex" flexDirection="column" gap={1.5} p={2}>
                                            {[
                                                {
                                                    label: "Status",
                                                    value: (
                                                        <Chip
                                                            label={selectedRequestRow?.Status || "-"}
                                                            sx={{
                                                                bgcolor:
                                                                    selectedRequestRow?.Status === "Pending"
                                                                        ? "#FEF3C7"
                                                                        : selectedRequestRow?.Status === "Approved"
                                                                            ? "#DCFCE7"
                                                                            : "#FEE2E2",
                                                                color:
                                                                    selectedRequestRow?.Status === "Pending"
                                                                        ? "#92400E"
                                                                        : selectedRequestRow?.Status === "Approved"
                                                                            ? "#166534"
                                                                            : "#991B1B",
                                                                fontWeight: 600,
                                                                borderRadius: 1,
                                                                height: 24,
                                                            }}
                                                        />
                                                    ),
                                                },
                                                {
                                                    label: "Applied Date",
                                                    value: selectedRequestRow?.EntryDate
                                                        ? Moment(selectedRequestRow.EntryDate).format("DD-MMM-YYYY")
                                                        : "-",
                                                },
                                                {
                                                    label: "Leave Type",
                                                    value: selectedRequestRow?.LeaveType || "-",
                                                },
                                                {
                                                    label: "Leave Date",
                                                    value: selectedRequestRow?.LeaveDate || "-",
                                                },
                                                {
                                                    label: "Remark",
                                                    value: selectedRequestRow?.LeaveRemarks || "-",
                                                    isLong: true,
                                                },
                                                {
                                                    label: "Team",
                                                    value: selectedRequestRow?.TeamName || "-",
                                                },
                                            ].map((item, index) => (
                                                <Box
                                                    key={index}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems={item.isLong ? "flex-start" : "center"}
                                                    gap={2}
                                                >
                                                    <Typography sx={{ fontSize: 12, color: "#717883" }}>
                                                        {item.label}
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            color: "#374151",
                                                            textAlign: "right",
                                                            maxWidth: "65%",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {item.value}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* FOOTER */}
                                        <Box
                                            sx={{

                                                borderTop: "1px solid #D1D5DB",
                                                px: 2,
                                                py: 1,
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            {/* Cancel */}
                                            <Button
                                                variant="text"
                                                sx={{
                                                    width: "68px",
                                                    height: "32px",
                                                    fontSize: "12px",
                                                    border: "1px solid #E5E7EB",
                                                    textDecoration: "underline",
                                                    color: "#E10F00",
                                                }}
                                                onClick={handleCancelLeave}
                                            >
                                                Cancel
                                            </Button>

                                            {/* Right Buttons */}
                                            <Box display="flex" gap={1}>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        width: "79px",
                                                        height: "32px",
                                                        fontSize: "12px",
                                                        bgcolor: "#FEE2E2",
                                                        color: "#DC2626",
                                                        "&:hover": { bgcolor: "#FEE2E2" },
                                                    }}
                                                    onClick={handleReject}
                                                >
                                                    Reject
                                                </Button>

                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        width: "91px",
                                                        height: "32px",
                                                        fontSize: "12px",
                                                        bgcolor: "#16A34A",
                                                        "&:hover": { bgcolor: "#16A34A" },
                                                    }}
                                                    onClick={handleApprove}

                                                >
                                                    Approve
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>

                                <Grid item>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            borderColor: "#D1D5DB"
                                        }}
                                    />
                                </Grid>
                                {/* RIGHT PANEL: Tables */}
                                <Grid item xs={12} md={7.6}>
                                    <Box
                                        sx={{
                                            height: "385px",
                                            overflowY: "auto",
                                            pr: 1,
                                        }}
                                    >
                                        <Grid container spacing={1}>
                                            {/* First Row */}
                                            <Grid item xs={12} md={6}>
                                                <SimpleTable
                                                    title="Upcoming Applied Leaves"
                                                    rows={upcomingLeaveData}
                                                    columns={upcomingLeaveColumns}
                                                    maxHeight={200}
                                                />
                                            </Grid>

                                            {selectedRequestRow?.LeaveDate?.split(",")?.length > 0 && (() => {
                                                const formattedDate =
                                                    selectedRequestRow.LeaveDate.split(",")[0].trim();

                                                const filteredProjectRows = projectImpactLeaveData?.filter(
                                                    (item) =>
                                                        format(new Date(item.LeaveDate), "dd-MMM-yyyy") === formattedDate
                                                );

                                                return (
                                                    <Grid item xs={12} md={6}>
                                                        <SimpleTable
                                                            title={`Project Impact (${formattedDate})`}
                                                            rows={filteredProjectRows}
                                                            columns={teamImpactColumns}
                                                            maxHeight={tableMaxHeight}
                                                        />
                                                    </Grid>
                                                );
                                            })()}

                                            {/* Second Row */}
                                            <Grid item xs={12} md={6}>
                                                <SimpleTable
                                                    title="Past Leaves"
                                                    rows={pastLeaveData}
                                                    columns={pastLeaveColumns}
                                                    maxHeight={200}
                                                />
                                            </Grid>

                                            {selectedRequestRow?.LeaveDate?.split(",")?.length > 0 && (() => {
                                                const formattedDate =
                                                    selectedRequestRow.LeaveDate.split(",")[0].trim();

                                                const filteredTeamRows = teamImpactLeaveData?.filter(
                                                    (item) =>
                                                        format(new Date(item.CheckDate), "dd-MMM-yyyy") === formattedDate
                                                );

                                                return (
                                                    <Grid item xs={12} md={6}>
                                                        <SimpleTable
                                                            title={`Team Impact (${formattedDate})`}
                                                            rows={filteredTeamRows}
                                                            columns={teamImpactColumns}
                                                            maxHeight={tableMaxHeight}
                                                        />
                                                    </Grid>
                                                );
                                            })()}

                                            {/* Remaining Dates */}
                                            {selectedRequestRow?.LeaveDate
                                                ?.split(",")
                                                ?.slice(1)
                                                ?.map((leaveDate, index) => {
                                                    const formattedDate = leaveDate.trim();

                                                    const filteredProjectRows = projectImpactLeaveData?.filter(
                                                        (item) =>
                                                            format(new Date(item.LeaveDate), "dd-MMM-yyyy") === formattedDate
                                                    );

                                                    const filteredTeamRows = teamImpactLeaveData?.filter(
                                                        (item) =>
                                                            format(new Date(item.CheckDate), "dd-MMM-yyyy") === formattedDate
                                                    );

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <Grid item xs={12} md={6}>
                                                                <SimpleTable
                                                                    title={`Project Impact (${formattedDate})`}
                                                                    rows={filteredProjectRows}
                                                                    columns={teamImpactColumns}
                                                                    maxHeight={tableMaxHeight}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6}>
                                                                <SimpleTable
                                                                    title={`Team Impact (${formattedDate})`}
                                                                    rows={filteredTeamRows}
                                                                    columns={teamImpactColumns}
                                                                    maxHeight={tableMaxHeight}
                                                                />
                                                            </Grid>
                                                        </React.Fragment>
                                                    );
                                                })}
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box >
                    </>
                )
                }
            </Box >
        </>
    );
}